import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { type GoldenNotification } from "./entity";

export const GoldenNotificationEntityConfig: HyperEntityConfig<GoldenNotification> =
  {
    allowApiCrud: false,
    allowApiRead: false,
  };
